import { GLOBAL_VALUES } from 'eebac/constants';
const BASE_PATH = 'KYC_INFO';

export const SET_KYC_INFO_DATA = `${BASE_PATH}/SET_KYC_INFO_DATA`;
export const CLEAR_KYC_INFO_DATA = `${BASE_PATH}/CLEAR_KYC_INFO_DATA`;
export const VALIDATE_KYC_INFO_DATA = `${BASE_PATH}/VALIDATE_KYC_INFO_DATA`;

export const setKycInfoData = data => ({
    type: SET_KYC_INFO_DATA,
    data
});

export const clearKycInfoData = data => ({
    type: CLEAR_KYC_INFO_DATA,
    data
});

export const validateKycInfoData = () => ({
    type: VALIDATE_KYC_INFO_DATA,
});

const initialState = {
    accountNumber: "",
    ifscCode: "",
    panNumber: "",
    nameOnPan: "",
    dateOnPan: "",
    addressProof: GLOBAL_VALUES.DEFAULT_ADDRESS_PROOF,
    addressProofCopy : {},

    accountNumberError: "",
    ifscCodeError: "",
    panNumberError: "",
    nameOnPanError: "",
    dateOnPanError: "",
    addressProofError: "",
    addressProofCopyError: "",

    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_KYC_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case CLEAR_KYC_INFO_DATA:
            return { ...initialState }
        case VALIDATE_KYC_INFO_DATA:
            return { ...state, validate: true }
    }

    return state;
}